import React from "react"
import styled from "styled-components"

export default function CompleteBG({ className }) {
  return (
    <Wrapper className={className}>
      <TWrapper className="w1">
        <Textline className="t1">
          0101010101010101010101010010101010111010101
        </Textline>
      </TWrapper>
      <TWrapper className="w2">
        <Textline className="t2">
          0101010101010101010101010010101010111010101
        </Textline>
      </TWrapper>
      <TWrapper className="w3">
        <Textline className="t3">
          0101010101010101010101010010101010111010101
        </Textline>
      </TWrapper>
      <TWrapper className="w4">
        <Textline className="t4">
          0101010101010101010101010010101010111010101
        </Textline>
      </TWrapper>
      <TWrapper className="w5">
        <Textline className="t5">
          0101010101010101010101010010101010111010101
        </Textline>
      </TWrapper>
      <TWrapper className="w6">
        <Textline className="t6">
          0101010101010101010101010010101010111010101
        </Textline>
      </TWrapper>
      {/* <Textline className="t2">
        01101011101010111010101010000101010000001010
      </Textline>
      <Textline className="t3">
        10101000101010KRYPTOGOKRYPTOGOKRYPTOGOKRYPTOGO
      </Textline>
      <Textline className="t4">
        010001010111 KRYPTOGO 1101101001001000101110111
      </Textline>
      <Textline className="t5">
        01101011101010111010101010000101010000001010
      </Textline>
      <Textline className="t6">
        01101011101010111010101010000101010000001010
      </Textline>
      <Textline className="t7">
        01101011101010111010101010000101010000001010
      </Textline> */}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
  height: 100vh;
  position: absolute;
  animation: spin 60s infinite;
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    30% {
      transform: rotate(270deg);
    }
    80% {
      transform: rotate(180deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
`

const TWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-15deg);
  width: 100px;
  height: 100px;
  /* border: 1px solid #fff; */
  display: flex;
  align-items: center;
  &.w2 {
    transform: translate(-50%, -50%) rotate(30deg);
  }
  &.w3 {
    transform: translate(-50%, -50%) rotate(80deg);
  }
  &.w4 {
    transform: translate(-50%, -50%) rotate(150deg);
  }
  &.w5 {
    transform: translate(-50%, -50%) rotate(220deg);
  }
  &.w6 {
    transform: translate(-50%, -50%) rotate(300deg);
  }
`

const Textline = styled.div`
  /* overflow: hidden; */
  display: inline-block;
  background: linear-gradient(to left, #00fbfffd 0%, rgba(0, 0, 0, 0) 50%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-position: 100%;
  background-size: 200%;
  animation: textCol 3s infinite linear;
  font-weight: 700;
  font-size: 24px;
  z-index: 0;

  /* 3D設置 */
  transform: perspective(200px) rotateY(-35deg);

  @keyframes textCol {
    0% {
      background-position: 0%;
      transform: translate(0, 0);
    }
    100% {
      background-position: -200%;
    }
  }
  &.t1 {
    animation-delay: -1.5s;
    /* scale: 1.3; */
    animation-timing-function: ease-out;
    animation-duration: 8s;
    margin-left: -100px;
  }
  &.t2 {
    animation-delay: 0.5s;
    opacity: 0.1;
    margin-left: -100px;
    animation-duration: 3s;
  }
  &.t3 {
    animation-delay: 0.5s;
    animation-duration: 5s;
    margin-left: -100px;
    opacity: 0.1;
  }
  &.t4 {
    animation-delay: -0.5s;
    animation-duration: 5s;
    margin-left: -100px;
    scale: 1;
    opacity: 0.5;
  }
  &.t5 {
    animation-delay: -0.5s;
    animation-duration: 5s;
    margin-left: -100px;
    scale: 1;
    opacity: 0.5;
  }
  &.t6 {
    animation-delay: -0.5s;
    animation-duration: 5s;
    margin-left: -100px;
    scale: 1;
    opacity: 0.1;
  }
  &.t7 {
    animation-delay: -0.5s;
    animation-duration: 3s;
    margin-left: -100px;
    scale: 3;
    opacity: 0.1;
  }
`
